module.exports = __webpack_public_path__ + "img/Alfonso.9eed7350.jpg";